export default {
    apiurl: process.env.NODE_ENV === "production"
        ? process.env.REACT_APP_API_URL
        : "http://localhost:5001",
    isDebugMode: false
}
